import { headerStyles as styles } from "@insite/content-library/Widgets/VmiLocations/VmiLocationsHeader";
import { css } from "styled-components";

styles.titleText = {
    css: css`
        display: none;
    `,
};
